import { ReferenceInput, required, SelectInput, useSimpleFormIteratorItem } from "react-admin";
import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import EmployeeInput from "server/components/Fields/EmployeeInput";
import { employeeRequests } from "api/employeeApi";
import { erasmusRequests } from "api/erasmusApi";

const COMMISSION_SOURCE = "commissionMembers";

const CommissionMemberFields = ({ structuralUnitId, excludeIds = [] }) => {
  if (!structuralUnitId) {
    return null;
  }

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={7}
      >
        <EmployeeInput
          source="employeeId"
          label="Служител (от факултета)"
          fullWidth
          validate={required()}
          reference={employeeRequests.getEmployeesWithDegreeSelect()}
          filters={excludeIds.length ? { structuralUnitId, ExcludeIds: excludeIds } : { structuralUnitId }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={5}
      >
        <ReferenceInput
          source="role"
          reference={erasmusRequests.getCommitionRolesSelect()}
        >
          <SelectInput
            label="Роля"
            optionText="nameBg"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
    </Grid>
  );
};

export const CommissionMemberIteratorItem = () => {
  const { index } = useSimpleFormIteratorItem();
  const members = useWatch({ name: COMMISSION_SOURCE });
  const structuralUnitId = useWatch({ name: "structuralUnitId" });

  // Keep an employee already picked in a sibling row out of this row's options.
  const excludeIds =
    members
      ?.filter((_, i) => i !== index)
      ?.map(member => member?.employeeId)
      ?.filter(Boolean) ?? [];

  return (
    <CommissionMemberFields
      structuralUnitId={structuralUnitId}
      excludeIds={excludeIds}
    />
  );
};

export default CommissionMemberFields;
